import React from 'react';
import { usePermissions } from '../../hooks/usePermissions';
import AdminDashboard from './AdminDashboard';
import AtendenteDashboard from './AtendenteDashboard';
import TecnicoDashboard from './TecnicoDashboard';
//import DefaultDashboard from './DefaultDashboard';

const Dashboard = () => {
  const { isAdmin, isAtendente, isTecnico } = usePermissions();

  if (isAdmin()) {
    return <AdminDashboard />;
  }
  
  if (isAtendente()) {
    return <AtendenteDashboard />;
  }
  
  if (isTecnico()) {
    return <TecnicoDashboard />;
  }
  
  return <AtendenteDashboard />;
};

export default Dashboard;